import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { SectionTitle } from 'page/ProfileScreen/basic/SectionTitle'
import { ChestSlider } from 'page/ProfileScreen/ChestSlider/ChestSlider'
import { HeightSlider } from 'page/ProfileScreen/HeightSlider/HeightSlider'
import { HipsSlider } from 'page/ProfileScreen/HipsSlider/HipsSlider'
import { Legs } from 'page/ProfileScreen/Legs/Legs'
import { ShouldersSlider } from 'page/ProfileScreen/ShouldersSlider/ShouldersSlider'
import { Units } from 'page/ProfileScreen/Units/Units'
import { WaistSlider } from 'page/ProfileScreen/WaistSlider/WaistSlider'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { showUnits } from 'type/LengthUnit'
import { DashedButton } from '../basic/DashedButton'

export const DetailedForm = observer(() => {
  const units = showUnits()
  const tsum = opt.tsum
  const height = opt.measurements.includes('height')
  const shoulders = opt.measurements.includes('shoulders')
  const bust = opt.measurements.includes('bust')
  const waist = opt.measurements.includes('waist')
  const hips = opt.measurements.includes('hips')
  const legLength = opt.measurements.includes('legLength')

  const onInfo = useLatestCallback(() => {
    store.profile.step = 'sizes'
  })

  return <Vertical gap={16}>
    {units && <Units />}
    {height && <HeightSlider />}
    {shoulders && <ShouldersSlider />}
    {bust && <ChestSlider />}
    {waist && <WaistSlider />}
    {hips && <HipsSlider />}
    {!tsum && legLength && <Vertical gap={12}>
      <Space gap={16} opposite wrap>
        <SectionTitle>
          {i18n('ChooseLegLength')}
        </SectionTitle>
        <DashedButton onClick={onInfo}>
          {i18n('HowToChooseLegLength')}
        </DashedButton>
      </Space>
      <Legs detailed />
    </Vertical>}
  </Vertical>
})
